module.exports = __webpack_public_path__ + "media/images/icon-planning-3762b8ca701a546a4c958e2b721a743e.svg";